import { useThemeSlice } from "../../components/ui/StatusBadge.jsx";
import { Ico } from "../../components/icons/icons.jsx";
import { AccountSelectDropdown } from "./components/AccountSelectDropdown.jsx";

export function AccountDetailHeader({ account, accounts, onBack, onSelectAccount }) {
  const { c } = useThemeSlice();

  return (
    <div style={{ padding: "10px 14px", borderBottom: `1px solid ${c.divider}`, background: c.sb, flexShrink: 0 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
        <button
          type="button"
          onClick={onBack}
          aria-label="Back to accounts"
          style={{ width: 30, height: 30, borderRadius: 7, border: `1px solid ${c.cardBdr}`, background: c.card, color: c.mid, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}
        >
          {Ico.chevronLeft}
        </button>
        <AccountSelectDropdown accounts={accounts} value={account.id} onChange={onSelectAccount} />
      </div>
    </div>
  );
}
